import { render, staticRenderFns } from "./ReferenceDraftTimer.vue?vue&type=template&id=bc2a9990"
import script from "./ReferenceDraftTimer.vue?vue&type=script&lang=js"
export * from "./ReferenceDraftTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports